export default {"src":"/_next/static/media/curve_line.853c6813.svg","height":68,"width":69,"blurWidth":0,"blurHeight":0};